import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import overlayimg from "./../../assets/images/anj-logo.jpg";
// Change this image path based on your actual banner image
import AnjapparBanner from "./../../assets/images/banner/fo.png";

const Anjappar = () => {
  pageTitle("Anjappar WhatsApp Marketing");

  return (
    <>
      <HeaderOne />

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${AnjapparBanner})` }}
      >
        {/* <img src={AiInvoiceBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          <img
            src={overlayimg}
            alt="Anjappar Logo"
            className="ai-overlay-corner-img"
          />
          {/* Centered text */}
          <div className="ai-overlay-center-project-text">
            <h2 className="ai-overlay-project">
              Anjappar Singapore<br></br>WhatsApp Marketing
            </h2>
          </div>
        </div>
      </div>

      <section className="anjappar-section">
        <div className="container">
          <div className="anjappar-intro-card">
            <span className="anjappar-tag">📣 WhatsApp Campaign System</span>

            <h3>About Anjappar Singapore WhatsApp Marketing</h3>

            <p>
              The Anjappar Singapore WhatsApp Marketing helps manage customer
              promotional communication through WhatsApp. It allows the business
              to send approved WhatsApp template campaigns, track customer
              opt-in preferences, and record unsubscribe requests such as STOP.
            </p>

            <p>
              Customers can join promotions by clicking the campaign button or
              by replying START. If a customer replies STOP, the system records
              the preference and marks the customer as unsubscribed for future
              promotional campaigns.
            </p>
          </div>

          <div className="anjappar-feature-grid">
            <div className="anjappar-feature-card">
              <div className="anjappar-icon">📢</div>
              <h4>Campaign Sending</h4>
              <p>
                Send approved WhatsApp promotional templates to individual
                customers or uploaded Excel customer lists.
              </p>
            </div>

            <div className="anjappar-feature-card">
              <div className="anjappar-icon">✅</div>
              <h4>Opt-in Tracking</h4>
              <p>
                Save customer opt-in actions such as Join Promotion, START, and
                Resume directly into the campaign preference Excel file.
              </p>
            </div>

            <div className="anjappar-feature-card">
              <div className="anjappar-icon">🛑</div>
              <h4>STOP Preference</h4>
              <p>
                Automatically record STOP replies and prevent unsubscribed
                customers from receiving future marketing messages.
              </p>
            </div>

            <div className="anjappar-feature-card">
              <div className="anjappar-icon">📊</div>
              <h4>Campaign Logs</h4>
              <p>
                Track sent, failed, duplicate, invalid, and campaign history
                records for reporting and review.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="anjappar-policy-section">
        <div className="container">
          <div className="anjappar-two-column">
            <div className="anjappar-info-box">
              <h3>Terms of Use</h3>

              <p>
                This dashboard is intended only for authorized Anjappar campaign
                users. Users must ensure that promotional messages are sent only
                to customers who have provided consent or are eligible to
                receive WhatsApp communication.
              </p>

              <p>
                Campaign templates must follow WhatsApp Business messaging
                policies. Users are responsible for checking customer data
                before sending campaigns.
              </p>

              <p>
                Any customer who replies STOP or opts out must not be included
                in future promotional campaigns unless they opt in again.
              </p>
            </div>

            <div className="anjappar-info-box">
              <h3>Privacy Policy</h3>

              <p>
                This system may store customer WhatsApp numbers, campaign
                status, opt-in status, unsubscribe status, preference message,
                timestamps, and campaign logs for campaign tracking purposes.
              </p>

              <p>
                Customer data is used only for Anjappar WhatsApp campaign
                management and preference handling. It should not be shared with
                unauthorized users or used for unrelated purposes.
              </p>

              <p>
                Customers can opt out of promotional messages by replying STOP.
                Once STOP is received, the system records the preference and
                marks the customer as unsubscribed.
              </p>
            </div>
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default Anjappar;
